import Menubar from "components/Menubar/Menubar";
import React from "react";
import { superAdminMenu } from "constants/superAdminMenu";

const SuperAdminMenubar = () => {
  return <Menubar color="primary" menu={superAdminMenu} alignCenter />;
};

export default SuperAdminMenubar;
